import { render, staticRenderFns } from "./Proto.vue?vue&type=template&id=113f85c6&scoped=true"
import script from "./Proto.vue?vue&type=script&lang=js"
export * from "./Proto.vue?vue&type=script&lang=js"
import style0 from "./Proto.vue?vue&type=style&index=0&id=113f85c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f85c6",
  null
  
)

export default component.exports